export default (that) => [
  {
    exportName: that.$l('INDEX.btn_export_productpacking') || '导出 产装通知书',
    templateGroup: 'shipment-productpacking',
    exportCheckUrl: '/factory/shipmentInfo/waitProductionLoad/checkData',
  },
  {
    exportName: that.$l('INDEX.btn_export_inventoryentrydetails') || '导出 进仓明细',
    templateGroup: 'shipment-inventoryentrydetails',
    exportCheckUrl: '/factory/shipmentInfo/waitProductionLoad/checkData',
  },
  {
    exportName: that.$l('INDEX.btn_export_packlist') || '导出 打包单',
    templateGroup: 'shipment-packlist',
    exportCheckUrl: '/factory/shipmentInfo/shipmentBatchPacking/checkData',
  },
  {
    exportName: that.$l('INDEX.btn_export_shipmentdetails') || '导出 出货明细',
    templateGroup: 'shipment-shipmentdetails',
    exportCheckUrl: '/factory/shipmentInfo/shipmentDetails/checkData',
  },
  {
    exportName: that.$l('INDEX.btn_export_shipmentTruckingOrder') || '导出 Trucking order',
    templateGroup: 'shipment-truckingOrder',
    exportCheckUrl: '/factory/shipmentInfo/waitProductionLoad/checkData',
  },
  {
    exportName: that.$l('INDEX.btn_export_shipmentPackingList') || '导出 Packing List',
    templateGroup: 'shipment-packingList',
    exportCheckUrl: '/factory/shipmentInfo/waitProductionLoad/checkData',
  },
  {
    exportName: that.$l('INDEX.btn_export_truckPlan') || '导出 Truck Plan',
    templateGroup: 'factory-truckPlan',
    exportCheckUrl: '/factory/shipmentInfo/waitProductionLoad/checkData',
  },
]
